/**
 * Public email domains used to detect personal email addresses.
 * These domains are commonly used for personal accounts rather than work emails.
 */
export const PUBLIC_EMAIL_DOMAINS = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com'];

/**
 * Checks if a domain is a public email domain.
 */
export const isPublicEmailDomain = (domain: string): boolean => PUBLIC_EMAIL_DOMAINS.includes(domain);
